@if (loading()) {
    <div class="loading">
        <div class="loading__overlay"></div>
        <div class="loading__icon">
            <mat-spinner [diameter]="diameter" />
        </div>
        <div class="loading__text">
            <ng-content></ng-content>
        </div>
    </div>
}
